import * as React from 'react';

import { context } from './context';
import { IFavoriteAction, EFavoriteAction } from './types';
import { TReduxActions } from '../../actions';
import { EAddToFavoritesActionTypes, TSuccessAddToFavorites } from '../../actions/newFavorites/addToFavorite';
import {
  ERemoveFromFavoritesActionTypes,
  TSuccessRemoveFromFavorites,
} from '../../actions/newFavorites/removeFromFavorite';

const FAVORITES_ACTIONS: TReduxActions['type'][] = [
  EAddToFavoritesActionTypes.Success,
  ERemoveFromFavoritesActionTypes.Success,
];

export function useFavoritesSubscriber(): IFavoriteAction | null {
  const reduxStore = React.useContext(context);
  const [lastFavoritesAction, setLastFavoritesAction] = React.useState<IFavoriteAction | null>(null);

  const storeListener = () => {
    const { lastAction } = reduxStore.getState();

    if (isFavoritesAction(lastAction)) {
      setLastFavoritesAction({
        action:
          lastAction.type === EAddToFavoritesActionTypes.Success ? EFavoriteAction.Added : EFavoriteAction.Removed,
        offerId: lastAction.payload.offerId,
      });
    }
  };

  React.useEffect(() => {
    return reduxStore.subscribe(storeListener);
  });

  return lastFavoritesAction;
}

function isFavoritesAction(action: TReduxActions): action is TSuccessAddToFavorites | TSuccessRemoveFromFavorites {
  return FAVORITES_ACTIONS.includes(action.type);
}
